import Animation from "@/Shared/Animations/Animation";

function UpdatedBillOfLadingAnimation() {
  return (
    <Animation
      width={200}
      speed={1.0}
      loop={true}
      pathToAnimation="/animations/updated-bill-of-lading-animation.json"
      lottieFilesUrl="https://lottiefiles.com/22128-document"
    />
  );
}
export default UpdatedBillOfLadingAnimation;
